import {runtimeStore} from '@/composables/store-accessor'
import {extraServicesTotalPrice, totalPrice} from '~/utils/price-helpers'

export const calcTotalPrice = prices => totalPrice(prices, runtimeStore.exchangeRates)
export const calcExtraServicesTotalPrice = (additionalOptions, extraServices) =>
    extraServicesTotalPrice(additionalOptions, extraServices, runtimeStore.exchangeRates)
